import { Component, Input } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TealCompEncounter } from '../../../models/encounter';
import { CalendarModule } from 'primeng/calendar';
import { EncounterService } from '../../../services/encounter.service';
import { Appointment, AppointmentInsert, ProviderLocationIdentifier } from '@harlowe/core';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-encounter-appointment-block',
  standalone: true,
  imports: [NgIf, TooltipModule, CardModule, PanelModule, ButtonModule, OverlayPanelModule, 
            CalendarModule,TableModule,DatePipe],
  templateUrl: './encounter-appointment-block.component.html',
  styleUrl: './encounter-appointment-block.component.scss'
})
export class EncounterAppointmentBlockComponent 
{
  @Input() encounter: TealCompEncounter | undefined;

  constructor(private _encounter:EncounterService)
  {

  }

  get locked() : boolean
  {
    if(this.encounter)
      return this.encounter.status >= 5
    else
      return false;
  }

  get scheduledAppointment() : Appointment | undefined
  {
    return this.encounter?.appointments?.find(a => a.status == 1);
  }


  get appointmentDate() : Date | undefined
  {
    //active appointment
    var ad = this.scheduledAppointment?.appointmentDate;
    return ad;
  }

  get completeAppointment() : Date | undefined
  {
    var ad = this.encounter?.appointments?.find(a => a.status == 2)?.appointmentDate;
    return ad;
  }

  get displayDate () : Date | undefined
  {
    if(this.completeAppointment)
      return new Date(this.completeAppointment);

    if(this.appointmentDate)
      return new Date(this.appointmentDate);

    return undefined;
  }

  monthNames: string[] = 
  [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  dayNames: string[] = 
  [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  get appointmentMonth() : string | undefined
  {
    return (this.displayDate == undefined || this.displayDate == null ? undefined : this.monthNames[this.displayDate.getMonth()]);
  }

  get appointmentDay() : string | undefined
  {
    return this.displayDate?.getDate().toString();
  }

  get appointmentDayName() :string | undefined
  {
    return (this.displayDate == undefined || this.displayDate == null ? undefined : this.dayNames[this.displayDate.getDay()]);
  }

  get appointmentYear() : string | undefined
  {
    return this.displayDate?.getFullYear().toString();
  }

  newAppointmentSelected(date: Date)
  {
    if(this.encounter && this.encounter.proposedProvider)
    {
      var pl = this.encounter.proposedProvider;
      var ai = new AppointmentInsert(date,new ProviderLocationIdentifier(pl.facility.ein,pl.facility.npi,pl.location.id));
      this._encounter.addAppointment(this.encounter.id,ai);
    }
  }

  cancelAppointment()
  {
    if(this.scheduledAppointment && this.encounter)
      {
        this._encounter.cancelAppointment(this.encounter.id,this.scheduledAppointment.id);
      }
  }
  
}
